import type { FaireProductEntity } from "../../entity_types/product";

export const p_bgxgtwcdfd: FaireProductEntity = {
  token: "p_bgxgtwcdfd",
  type: "product",
  name: "Brickcraft Crystal Style Vase Brick Building Set",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/b71a2dceaef15137506ba85d094396f7f9f7b8a6cf0b4195c707706bf832df33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/374e90364c8f57048f40988d92484c77811ed55569844b08be850f8bed0390ac.jpeg",
    "https://cdn.faire.com/fastly/c82517faa3e26812f3baecd37c833682fcf1df9678a37436170803cc8b9ec71c.jpeg",
    "https://cdn.faire.com/fastly/b2f664da5d6c29a569d11bb7bd0e73b35b4e0012169faf94df918c1198659426.jpeg",
    "https://cdn.faire.com/fastly/f8307fdea0dc6dec881fc7b0a98f3253a88488843de3eaf4026fd98fe29b9401.jpeg",
    "https://cdn.faire.com/fastly/98f00fd12ed59c4167138ef77a32b599de458fdbb429dd7ff0bd750be989f35b.jpeg",
    "https://cdn.faire.com/fastly/b8b4f56115821875a4a9734e0048c9551a9a9df50df562a5ae3b493cf264eac5.jpeg",
    "https://cdn.faire.com/fastly/199d473bd77282872d5d1829c3c686661b8a8b4faf41f22ea84d8be1567f7b5c.jpeg",
  ],
  priceDollars: 8.27,
  description:
    "Buy 8 Bricktanicals sets, get 10% off!\n\nMade entirely from transparent bricks, this sleek and stackable vase is designed to hold up to 10 Brickcraft flowers while giving your display a clear, glass-like finish. The cylindrical form and sturdy construction make it a beautiful base for your custom arrangements. With its elegant silhouette and versatile design, the Crystal Vase is the perfect companion to any Bricktanicals flower build.",
  tags: [],
  msrpDollars: 16.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:56.630Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
